import ConstChart from '../../common/mixChart/Const';
import { formatPercent, formatTextFloat } from '../../helpers/Text';
import moment from 'moment';

const isFloat = n => Number(n) === n && n % 1 !== 0;

const formatTick = d => formatTextFloat(d, isFloat(d) ? 2 : 0);

const SETTINGS = {
  HEIGHT: 200,
  WIDTH: 400,
  MARGIN: { left: 70, right: 70, top: 30, bottom: 30 },
  TEXT_COLOR: '#ffffff',
  TEXT_COLOR_TOOLTIP: '#000',
  TEXT_SM_SIZE: 10,
  TEXT_MD_SIZE: 12,
  TEXT_LG_SIZE: 14,
  BIG_SIZE: 20,
  CHART_INDEX: {
    COLOR: '#47c3ff',
    HEIGHT: 300,
  },
  CHART_RATE: {
    COLOR: '#facc5c',
    HEIGHT: 300,
  },
  KEY_CHART: 1,
  MIN_WIDTH: 500,
  timeMap: {
    QUARTERLY: 'timeTab.quarterly',
    YEARLY: 'timeTab.yearly',
  },
  formatBillion: 'formatBillion',
  formatMilliion: 'formatMilliion',
  formatTextFloat: 'formatTextFloat',
  formatTextFloat0: 'formatTextFloat0',
  formatPercent: 'formatPercent',
  isYRange: 'isYRange',
};
const marginsExport = {
  top: 80,
  bottom: 16,
  left: 20,
  leftChild: 32,
};

const exportConfigs = isBanking => {
  return {
    page: {
      width: 928,
      height: isBanking ? 1306 : 1572,
    },
    listPromise: {
      data: [
        {
          isId: false,
          className: '.headerAndFooterPdf',
          config: {
            x: 0,
            y: 0,
            width: 928,
            height: isBanking ? 1306 : 1572,
          },
        },
      ],
    },
    listConfigs: {
      height: 866,
      top: 80,
      data: [
        {
          isId: true,
          idName: '#search',
          config: {
            x: marginsExport.left,
            y: marginsExport.bottom,
            width: 150,
            height: 60,
          },
        },
        {
          isId: true,
          idName: '#score',
          config: {
            x: 160,
            y: marginsExport.bottom,
            width: 305,
            height: 60,
          },
        },
        {
          isId: false,
          className: '.fa-top-content .notifications-wrapper',
          config: {
            x: 491,
            y: marginsExport.bottom,
            width: 400,
            height: 60,
          },
        },
        {
          isId: false,
          className: '.snapShotTable-Chart',
          config: {
            x: marginsExport.leftChild,
            y: marginsExport.bottom + 92,
            width: 500,
            height: 180,
          },
        },
        {
          isId: false,
          className: '.snapShotTable-Infor',
          config: {
            x: 548,
            y: marginsExport.bottom + 92,
            width: 349,
            height: 180,
          },
        },
        {
          isId: false,
          className: '.snapShot-titleFinancialPer',
          config: {
            x: marginsExport.leftChild,
            y: marginsExport.bottom + 307,
            width: 158,
            height: 18,
          },
        },
        {
          isId: false,
          className: '.snapShot-FinancialPer-tab',
          config: {
            x: 720,
            y: marginsExport.bottom + 307,
            width: 165,
            height: 28,
          },
        },
        {
          isId: false,
          isMultiChild: true,
          numberChildInRow: 3,
          className: '.mix-chart',
          config: {
            x: marginsExport.leftChild,
            y: marginsExport.bottom + 341,
            width: 262,
            height: 226,
            paddingBetweenChild: 20,
          },
        },
      ],
    },

    listRoundRect: [
      {
        strokeColor: '#969696',
        radius: 10,
        x: 16,
        y: 172,
        width: 896,
        height: isBanking ? 733 : 999,
        isFill: false,
        isStroke: true,
      },
    ],
    listLines: [
      {
        strokeColor: '#969696',
        x1: 16,
        y1: 391,
        x2: 912,
        y2: 391,
      },
    ],
  };
};

const xAccessor = d => {
  return d.category;
};
const xExtents = 'category';
const margin = { left: 70, right: 53, top: 10, bottom: 30 };
const eventSynchTooltipName = 'snapshot_' + moment().unix();
const yGrid = {
  innerTickSize:
    -1 * (SETTINGS.WIDTH - SETTINGS.MARGIN.left - SETTINGS.MARGIN.right),
  tickStrokeDasharray: 'Solid',
  tickStrokeOpacity: 0.2,
  tickStrokeWidth: 2,
};
const colorSeries = {
  barChart: {
    fillColor: '#1d97ef',
    fillColorHover: '#f1ffe7',
    fillColorHoverLight: '#2b457d',
  },
  stackBarChart: {
    fillColor1: '#0060a6',
    fillColor2: '#ff959c',
    fillColor3: '#ffe1ca',
    hover: {
      fillColor1: '#f88634',
      fillColor2: '#facc5c',
      fillColor3: '#f1ffe7',
    },
    hoverLightMode: {
      fillColor1: '#2b457d',
      fillColor2: '#2c73e8',
      fillColor3: '#a2c2f7',
    },
  },
  lineChart: {
    squareFillColor: '#9deaef',
    triangleFillColor: '#ee6352',
    circleFillColor: '#f5d0c5',
  },
  lineChartLight: {
    squareFillColor: '#00c6ba',
    triangleFillColor: '#ee6352',
    circleFillColor: '#ffb7a2',
  },
};
const XAxis = {
  axisAt: 'bottom',
  orient: 'bottom',
};
const typeTriangleMarker = {
  width: 8,
  stroke: colorSeries.lineChart.triangleFillColor,
  fill: colorSeries.lineChart.triangleFillColor,
  fillLight: colorSeries.lineChartLight.triangleFillColor,
  opacity: 1,
  strokeWidth: 0,
};
const typeSquareMarker = {
  width: 6,
  stroke: colorSeries.lineChart.squareFillColor,
  fillLight: colorSeries.lineChartLight.squareFillColor,
  fill: colorSeries.lineChart.squareFillColor,
  opacity: 1,
  strokeWidth: 0,
};
const typeCircleMarker = {
  r: 1,
  fill: colorSeries.lineChart.circleFillColor,
  fillLight: colorSeries.lineChartLight.circleFillColor,
  opacity: 1,
  strokeWidth: 0,
};

const titleYAxisLeft = text => {
  return {
    x: -55,
    y:
      SETTINGS.MARGIN.top +
      (SETTINGS.HEIGHT - SETTINGS.MARGIN.top - SETTINGS.MARGIN.bottom) / 2,
    text: text,
  };
};
const titleYAxisRight = text => {
  return {
    x: SETTINGS.WIDTH - SETTINGS.MARGIN.left - SETTINGS.MARGIN.right * 0.6,
    y:
      SETTINGS.MARGIN.top +
      (SETTINGS.HEIGHT - SETTINGS.MARGIN.top - SETTINGS.MARGIN.bottom) / 2,
    rotate: 90,
    text: text,
  };
};

//#region capital structure ratio
const titleCapitalStructureRatio = {
  title: 'snapShot.chartNonBank.chartCapitalStructure.title',
};
const YAxisChartCapitalStructureRatio = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartCapitalStructure.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipCapitalStructureRatio = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartCapitalStructure.tooltipDebt',
      d => [d.category, formatTextFloat(d.rqq10)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartCapitalStructure.tooltipLTBorrwing',
      d => [d.category, formatTextFloat(d.rqq6)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const seriesCapitalStructureRatio = [
  ConstChart.setConfigLineSeries(
    'rqq10',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq6',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const yExtentsCapitalStructureRatio = ['rqq10', 'rqq6'];
const listLegendCapitalStructureRatio = [
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartCapitalStructure.legendDebt',
    colorSeries.lineChart.squareFillColor,
    colorSeries.lineChartLight.squareFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartCapitalStructure.legendLTBorrwing',
    colorSeries.lineChart.circleFillColor,
    colorSeries.lineChartLight.circleFillColor,
  ),
];
const chartsCapitalStructureItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipCapitalStructureRatio,
    yExtentsCapitalStructureRatio,
    YAxisChartCapitalStructureRatio,
    XAxis,
    seriesCapitalStructureRatio,
  ),
];

const configChartCapitalStructureRatio = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendCapitalStructureRatio,
  titleCapitalStructureRatio,
  chartsCapitalStructureItems,
  true,
  eventSynchTooltipName,
);
//#endregion capital structure ratio

//#region chart return on capital
const titleChartReturnOnCapital = {
  title: 'snapShot.chartNonBank.chartReturnOnCapital.title',
};
const YAxisChartReturnOnCapital = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartReturnOnCapital.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartReturnOnCapital = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartReturnOnCapital.tooltipROE',
      d => [d.category, formatTextFloat(d.rqq12)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartReturnOnCapital.tooltipROIC',
      d => [d.category, formatTextFloat(d.rqq76)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const seriesChartReturnOnCapital = [
  ConstChart.setConfigLineSeries(
    'rqq12',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq76',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const yExtentsChartReturnOnCapital = ['rqq12', 'rqq76'];
const listLegendChartReturnOnCapital = [
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartReturnOnCapital.legendROE',
    colorSeries.lineChart.squareFillColor,
    colorSeries.lineChartLight.squareFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartReturnOnCapital.legendROIC',
    colorSeries.lineChart.circleFillColor,
    colorSeries.lineChartLight.circleFillColor,
  ),
];
const chartsChartReturnOnCapitalItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartReturnOnCapital,
    yExtentsChartReturnOnCapital,
    YAxisChartReturnOnCapital,
    XAxis,
    seriesChartReturnOnCapital,
  ),
];

const configChartReturnOnCapital = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartReturnOnCapital,
  titleChartReturnOnCapital,
  chartsChartReturnOnCapitalItems,
  true,
  eventSynchTooltipName,
);
//#endregion chart return on capital

//#region operating ratio
const titleOperatingRatio = {
  title: 'snapShot.chartNonBank.chartOperating.title',
};
const YAxisOperationRatio = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartOperating.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipOperatingRatio = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperating.tooltipCashCycle',
      d => [d.category, formatTextFloat(d.cashCycle)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperating.tooltipDaysSaleOutstanding',
      d => [d.category, formatTextFloat(d.rqq16)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperating.tooltipDaysPayableOutstanding',
      d => [d.category, formatTextFloat(d.rqq20)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperating.tooltipDaysInventoryOutstanding',
      d => [d.category, formatTextFloat(d.rqq18)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const seriesOperatingRatio = [
  ConstChart.setConfigBarSeries(
    'cashCycle',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq16',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq20',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq18',
    colorSeries.lineChart.triangleFillColor,
    ConstChart.TriangleMarker,
    typeTriangleMarker,
    2,
    colorSeries.lineChartLight.triangleFillColor,
    true,
  ),
];
const yExtentsOperatingRatio = ['rqq16', 'rqq20', 'rqq18', 'cashCycle'];
const listLegendOperatingRatio = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartNonBank.chartOperating.legendCashCycle',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartOperating.legendDaysSaleOutstanding',
    colorSeries.lineChart.squareFillColor,
    colorSeries.lineChartLight.squareFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartOperating.legendDaysPayableOutstandingOutstanding',
    colorSeries.lineChart.circleFillColor,
    colorSeries.lineChartLight.circleFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.TRIANGLEMARKERLINE,
    'snapShot.chartNonBank.chartOperating.legendDaysInventoryOutstanding',
    colorSeries.lineChart.triangleFillColor,
    colorSeries.lineChartLight.triangleFillColor,
  ),
];
const chartsOperatingItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipOperatingRatio,
    yExtentsOperatingRatio,
    YAxisOperationRatio,
    XAxis,
    seriesOperatingRatio,
  ),
];

const configChartOperatingRatio = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendOperatingRatio,
  titleOperatingRatio,
  chartsOperatingItems,
  true,
  eventSynchTooltipName,
);
//#endregion operating ratio

//#region configChartRevenue
const titleChartRevenue = { title: 'snapShot.chartNonBank.chartRevenue.title' };
const YAxisChartRevenue = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartRevenue.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartRevenue = ConstChart.hoverTooltipFunc(null, null, null, [
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartRevenue.tooltipNetSales',
    d => [d.category, formatTextFloat(d.netSales)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartRevenue.tooltipAssetTurnover',
    d => [d.category, formatTextFloat(d.rqq31)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartRevenue.tooltipFixedAssetTurnover',
    d => [d.category, formatTextFloat(d.rqq91)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
]);
const seriesChartRevenue = [
  ConstChart.setConfigBarSeries(
    'netSales',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];
const yExtentsChartRevenue = ['netSales'];
const listLegendChartRevenue = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartNonBank.chartRevenue.legendNetSales',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartRevenue.legendAssetTurnover',
    colorSeries.lineChart.circleFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartRevenue.legendFixedAssetTurnover',
    colorSeries.lineChart.squareFillColor,
  ),
];

const yExtentsRightChartRevenue = ['rqq31', 'rqq91'];
const YAxisRightChartRevenue = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartNonBank.chartRevenue.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartRevenue = [
  ConstChart.setConfigLineSeries(
    'rqq31',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq91',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
];

const chartsRevenueItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartRevenue,
    yExtentsChartRevenue,
    YAxisChartRevenue,
    XAxis,
    seriesChartRevenue,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartRevenue,
    YAxisRightChartRevenue,
    null,
    seriesRightChartRevenue,
  ),
];

const configChartRevenue = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartRevenue,
  titleChartRevenue,
  chartsRevenueItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartRevenue

//#region configChartProfitability
const yExtentsLeftChartProfitability = ['isa22'];
const titleChartProfitability = {
  title: 'snapShot.chartNonBank.chartProfit.title',
};
const YAxisLeftChartProfitability = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartProfit.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartProfitability = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartProfit.tooltipNetProfit',
      d => [d.category, formatTextFloat(d.isa22)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartProfit.tooltipGrossProfitMargin',
      d => [d.category, formatTextFloat(d.rqq25)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartProfit.tooltipEBITMargin',
      d => [d.category, formatTextFloat(d.rqq27)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartProfit.tooltipNetProfitMargin',
      d => [d.category, formatTextFloat(d.rqq29)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const seriesLeftChartProfitability = [
  ConstChart.setConfigBarSeries(
    'isa22',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];

const yExtentsRightChartProfitability = ['rqq25', 'rqq27', 'rqq29'];

const YAxisRightChartProfitability = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartNonBank.chartProfit.yAxis2Title'),
  ),
  tickFormat: formatTick,
};

const seriesRightChartProfitability = [
  ConstChart.setConfigLineSeries(
    'rqq27',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq25',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq29',
    colorSeries.lineChart.triangleFillColor,
    ConstChart.TriangleMarker,
    typeTriangleMarker,
    2,
    colorSeries.lineChartLight.triangleFillColor,
    true,
  ),
];
const listLegendChartProfitability = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartNonBank.chartProfit.legendNetProfit',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartProfit.legendGrossProfitMargin',
    colorSeries.lineChart.squareFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartProfit.legendEBITMargin',
    colorSeries.lineChart.circleFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.TRIANGLEMARKERLINE,
    'snapShot.chartNonBank.chartProfit.legendNetProfitMargin',
    colorSeries.lineChart.triangleFillColor,
  ),
];
const chartsProfitabilityItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartProfitability,
    yExtentsLeftChartProfitability,
    YAxisLeftChartProfitability,
    XAxis,
    seriesLeftChartProfitability,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartProfitability,
    YAxisRightChartProfitability,
    null,
    seriesRightChartProfitability,
  ),
];

const configChartProfitability = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartProfitability,
  titleChartProfitability,
  chartsProfitabilityItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartProfitability

//#region dupont
const yExtentsLeftChartDupont = ['rqq12', 'rqq52'];
const titleChartDupont = {
  title: 'snapShot.chartNonBank.chartDupont.title',
};
const YAxisLeftChartDupont = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartDupont.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartDupont = ConstChart.hoverTooltipFunc(null, null, null, [
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartDupont.tooltipROE',
    d => [d.category, formatTextFloat(d.rqq12)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartDupont.tooltipNetProfitMargin',
    d => [d.category, formatTextFloat(d.rqq52)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartDupont.tooltipFinancialLeverage',
    d => [d.category, formatTextFloat(d.rqq71)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartNonBank.chartDupont.tooltipAssetTurnover',
    d => [d.category, formatTextFloat(d.rqq53)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
]);
const seriesLeftChartDupont = [
  ConstChart.setConfigBarSeries(
    'rqq12',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq52',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
];

const yExtentsRightChartDupont = ['rqq71', 'rqq53'];
const YAxisRightChartDupont = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartNonBank.chartDupont.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartDupont = [
  ConstChart.setConfigLineSeries(
    'rqq71',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'rqq53',
    colorSeries.lineChart.triangleFillColor,
    ConstChart.TriangleMarker,
    typeTriangleMarker,
    2,
    colorSeries.lineChartLight.triangleFillColor,
    true,
  ),
];
const listLegendChartDupont = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartNonBank.chartDupont.legendROE',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartDupont.legendNetProfitMargin',
    colorSeries.lineChart.squareFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartDupont.legendFinancialLeverage',
    colorSeries.lineChart.circleFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.TRIANGLEMARKERLINE,
    'snapShot.chartNonBank.chartDupont.legendAssetTurnover',
    colorSeries.lineChart.triangleFillColor,
  ),
];
const chartsDupontItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartDupont,
    yExtentsLeftChartDupont,
    YAxisLeftChartDupont,
    XAxis,
    seriesLeftChartDupont,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartDupont,
    YAxisRightChartDupont,
    null,
    seriesRightChartDupont,
  ),
];

const configChartDupont = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartDupont,
  titleChartDupont,
  chartsDupontItems,
  true,
  eventSynchTooltipName,
);
//#endregion dupont

//#region config chart operating cash flow
const yExtentsLeftChartOperatingCashFlow = ['cfa18', 'cfa10', 'cfa11', 'cfa12'];
const titleChartOperatingCashFlow = {
  title: 'snapShot.chartNonBank.chartOperatingCashFlow.title',
};
const YAxisLeftChartOperatingCashFlow = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartOperatingCashFlow.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartOperatingCashFlow = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperatingCashFlow.tooltipCFO',
      d => [d.category, formatTextFloat(d.cfa18)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperatingCashFlow.tooltipReceivable',
      d => [
        d.category,
        formatTextFloat(d.cfa10),
        d.commonCfaStatus ? '+/-' : '',
      ],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperatingCashFlow.tooltipPayable',
      d => [
        d.category,
        formatTextFloat(d.cfa12),
        d.commonCfaStatus ? '+/-' : '',
      ],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartOperatingCashFlow.tooltipInventory',
      d => [
        d.category,
        formatTextFloat(d.cfa11),
        d.commonCfaStatus ? '+/-' : '',
      ],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const seriesLeftChartOperatingCashFlow = [
  ConstChart.setConfigBarSeries(
    'cfa18',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'cfa10',
    colorSeries.lineChart.squareFillColor,
    ConstChart.SquareMarker,
    typeSquareMarker,
    2,
    colorSeries.lineChartLight.squareFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'cfa12',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
  ConstChart.setConfigLineSeries(
    'cfa11',
    colorSeries.lineChart.triangleFillColor,
    ConstChart.TriangleMarker,
    typeTriangleMarker,
    2,
    colorSeries.lineChartLight.triangleFillColor,
    true,
  ),
];

const listLegendChartOperatingCashFlow = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartNonBank.chartOperatingCashFlow.legendCFO',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.SQUAREMARKERLINE,
    'snapShot.chartNonBank.chartOperatingCashFlow.legendReceivable',
    colorSeries.lineChart.squareFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartNonBank.chartOperatingCashFlow.legendPayable',
    colorSeries.lineChart.circleFillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.TRIANGLEMARKERLINE,
    'snapShot.chartNonBank.chartOperatingCashFlow.legendInventory',
    colorSeries.lineChart.triangleFillColor,
  ),
];
const chartsOperatingCashFlowItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartOperatingCashFlow,
    yExtentsLeftChartOperatingCashFlow,
    YAxisLeftChartOperatingCashFlow,
    XAxis,
    seriesLeftChartOperatingCashFlow,
  ),
];

const configChartOperatingCashFlow = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartOperatingCashFlow,
  titleChartOperatingCashFlow,
  chartsOperatingCashFlowItems,
  true,
  eventSynchTooltipName,
);
//#endregion config chart operating cash flow

//#region configChartCashFlow
const titleChartCashFlow = {
  title: 'snapShot.chartNonBank.chartCashFlow.title',
};
const YAxisChartCashFlow = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartNonBank.chartCashFlow.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartCashFlow = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartCashFlow.tooltipCFO',
      d => [d.category, formatTextFloat(d.cfa18)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartCashFlow.tooltipNCFI',
      d => [d.category, formatTextFloat(d.cfa26)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartNonBank.chartCashFlow.tooltipNCFF',
      d => [d.category, formatTextFloat(d.cfa34)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);

const seriesChartCashFlow = [
  {
    type: ConstChart.StackedBarSeries,
    yAccessor: [d => d.cfa18, d => d.cfa34, d => d.cfa26],
    arrayColor: [
      colorSeries.stackBarChart.fillColor1,
      colorSeries.stackBarChart.fillColor2,
      colorSeries.stackBarChart.fillColor3,
    ],
    arrayColorHover: [
      colorSeries.stackBarChart.hover.fillColor1,
      colorSeries.stackBarChart.hover.fillColor2,
      colorSeries.stackBarChart.hover.fillColor3,
    ],
    arrayColorHoverLight: [
      colorSeries.stackBarChart.hoverLightMode.fillColor1,
      colorSeries.stackBarChart.hoverLightMode.fillColor2,
      colorSeries.stackBarChart.hoverLightMode.fillColor3,
    ],
    highlightOnHover: true,
  },
];
const yExtentsChartCashFlow = ['cfa18', 'cfa34', 'cfa26'];

const listLegendChartCashFlow = [
  ConstChart.setLegendConfig(
    ConstChart.GROUPCHART,
    'snapShot.chartNonBank.chartCashFlow.legendCFO',
    colorSeries.stackBarChart.fillColor1,
  ),
  ConstChart.setLegendConfig(
    ConstChart.GROUPCHART,
    'snapShot.chartNonBank.chartCashFlow.legendNCFI',
    colorSeries.stackBarChart.fillColor3,
  ),
  ConstChart.setLegendConfig(
    ConstChart.GROUPCHART,
    'snapShot.chartNonBank.chartCashFlow.legendNCFF',
    colorSeries.stackBarChart.fillColor2,
  ),
];
const chartsCashFlowItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartCashFlow,
    yExtentsChartCashFlow,
    YAxisChartCashFlow,
    XAxis,
    seriesChartCashFlow,
    true,
  ),
];

const configChartCashFlow = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartCashFlow,
  titleChartCashFlow,
  chartsCashFlowItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartCashFlow

//#region configChartNetInterestIncome
const yExtentsLeftChartNetInterestIncome = ['isb27'];
const titleChartNetInterestIncome = {
  title: 'snapShot.chartBank.chartNetInterestIncome.title',
};
const YAxisLeftChartNetInterestIncome = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartBank.chartNetInterestIncome.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const HoverTooltipChartNetInterestIncome = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartNetInterestIncome.tooltipNII',
      d => [d.category, formatTextFloat(d.isb27)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartNetInterestIncome.tooltipNIM',
      d => [d.category, formatTextFloat(d.rtq44)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const seriesLeftChartNetInterestIncome = [
  ConstChart.setConfigBarSeries(
    'isb27',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];

const yExtentsRightChartNetInterestIncome = ['rtq44'];
const YAxisRightChartNetInterestIncome = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartBank.chartNetInterestIncome.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartNetInterestIncome = [
  ConstChart.setConfigLineSeries(
    'rtq44',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const listLegendChartNetInterestIncome = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartBank.chartNetInterestIncome.legendNII',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartBank.chartNetInterestIncome.legendNIM',
    colorSeries.lineChart.circleFillColor,
  ),
];
const chartsNetInterestIncomeItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartNetInterestIncome,
    yExtentsLeftChartNetInterestIncome,
    YAxisLeftChartNetInterestIncome,
    XAxis,
    seriesLeftChartNetInterestIncome,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartNetInterestIncome,
    YAxisRightChartNetInterestIncome,
    null,
    seriesRightChartNetInterestIncome,
  ),
];

const configChartNetInterestIncome = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartNetInterestIncome,
  titleChartNetInterestIncome,
  chartsNetInterestIncomeItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartNetInterestIncome

//#region configChartNetProfit
const yExtentsLeftChartNetProfit = ['isa22'];
const titleChartNetProfit = {
  title: 'snapShot.chartBank.chartNetProfit.title',
};
const YAxisLeftChartNetProfit = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartBank.chartNetProfit.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const seriesLeftChartNetProfit = [
  ConstChart.setConfigBarSeries(
    'isa22',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];
const HoverTooltipChartNetProfit = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartNetProfit.tooltipNetProfit',
      d => [d.category, formatTextFloat(d.isa22)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartNetProfit.tooltipGrowth',
      d => [d.category, formatTextFloat(d.netProfitGrowth)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);

const yExtentsRightChartNetProfit = ['netProfitGrowth'];
const YAxisRightChartNetProfit = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartBank.chartNetProfit.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartNetProfit = [
  ConstChart.setConfigLineSeries(
    'netProfitGrowth',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const listLegendChartNetProfit = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartBank.chartNetProfit.legendNetProfit',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartBank.chartNetProfit.legendGrowth',
    colorSeries.lineChart.circleFillColor,
  ),
];
const chartsNetProfitItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartNetProfit,
    yExtentsLeftChartNetProfit,
    YAxisLeftChartNetProfit,
    XAxis,
    seriesLeftChartNetProfit,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartNetProfit,
    YAxisRightChartNetProfit,
    null,
    seriesRightChartNetProfit,
  ),
];

const configChartNetProfit = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartNetProfit,
  titleChartNetProfit,
  chartsNetProfitItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartNetProfit

//#region configChartBankTotalAsset
const yExtentsLeftChartBankTotalAsset = ['bsa53'];
const titleChartBankTotalAsset = {
  title: 'snapShot.chartBank.chartBankTotalAsset.title',
};
const YAxisLeftChartBankTotalAsset = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartBank.chartBankTotalAsset.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const seriesLeftChartBankTotalAsset = [
  ConstChart.setConfigBarSeries(
    'bsa53',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];
const HoverTooltipChartBankTotalAsset = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartBankTotalAsset.tooltipTotalAsset',
      d => [d.category, formatTextFloat(d.bsa53)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartBankTotalAsset.tooltipGrowth',
      d => [d.category, formatTextFloat(d.totalAssetGrowth)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);

const yExtentsRightChartBankTotalAsset = ['totalAssetGrowth'];
const YAxisRightChartBankTotalAsset = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartBank.chartBankTotalAsset.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartBankTotalAsset = [
  ConstChart.setConfigLineSeries(
    'totalAssetGrowth',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const listLegendChartBankTotalAsset = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartBank.chartBankTotalAsset.legendTotalAsset',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartBank.chartBankTotalAsset.legendGrowth',
    colorSeries.lineChart.circleFillColor,
  ),
];
const chartsBankTotalAssetItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartBankTotalAsset,
    yExtentsLeftChartBankTotalAsset,
    YAxisLeftChartBankTotalAsset,
    XAxis,
    seriesLeftChartBankTotalAsset,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartBankTotalAsset,
    YAxisRightChartBankTotalAsset,
    null,
    seriesRightChartBankTotalAsset,
  ),
];

const configChartBankTotalAsset = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartBankTotalAsset,
  titleChartBankTotalAsset,
  chartsBankTotalAssetItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartBankTotalAsset

//#region configChartBadDebt
const yExtentsLeftChartBadDebt = ['nob44'];
const titleChartBadDebt = { title: 'snapShot.chartBank.chartBadDebt.title' };
const YAxisLeftChartBadDebt = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartBank.chartBadDebt.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const seriesLeftChartBadDebt = [
  ConstChart.setConfigBarSeries(
    'nob44',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];
const HoverTooltipChartBadDebt = ConstChart.hoverTooltipFunc(null, null, null, [
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartBank.chartBadDebt.tooltipBadDebtValue',
    d => [d.category, formatTextFloat(d.nob44)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
  ConstChart.setContentTooltip(
    '',
    'snapShot.chartBank.chartBadDebt.tooltipBadDebtRatio',
    d => [d.category, formatTextFloat(d.rtq137)],
    SETTINGS.TEXT_COLOR_TOOLTIP,
  ),
]);

const yExtentsRightChartBadDebt = ['rtq137'];
const YAxisRightChartBadDebt = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartBank.chartBadDebt.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartBadDebt = [
  ConstChart.setConfigLineSeries(
    'rtq137',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const listLegendChartBadDebt = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartBank.chartBadDebt.legendBadDebtValue',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartBank.chartBadDebt.legendBadDebtRatio',
    colorSeries.lineChart.circleFillColor,
  ),
];
const chartsBadDebtItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartBadDebt,
    yExtentsLeftChartBadDebt,
    YAxisLeftChartBadDebt,
    XAxis,
    seriesLeftChartBadDebt,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartBadDebt,
    YAxisRightChartBadDebt,
    null,
    seriesRightChartBadDebt,
  ),
];

const configChartBadDebt = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartBadDebt,
  titleChartBadDebt,
  chartsBadDebtItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartBadDebt

//#region configChartTotalCredit
const yExtentsLeftChartTotalCredit = ['loans'];
const titleChartTotalCredit = {
  title: 'snapShot.chartBank.chartTotalCredit.title',
};
const YAxisLeftChartTotalCredit = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartBank.chartTotalCredit.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const seriesLeftChartTotalCredit = [
  ConstChart.setConfigBarSeries(
    'loans',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];
const HoverTooltipChartTotalCredit = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartTotalCredit.tooltipLoans',
      d => [d.category, formatTextFloat(d.loans)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartTotalCredit.tooltipGrowth',
      d => [d.category, formatTextFloat(d.loansGrowth)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);

const yExtentsRightChartTotalCredit = ['loansGrowth'];
const YAxisRightChartTotalCredit = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartBank.chartTotalCredit.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartTotalCredit = [
  ConstChart.setConfigLineSeries(
    'loansGrowth',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const listLegendChartTotalCredit = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartBank.chartTotalCredit.legendLoans',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartBank.chartTotalCredit.legendGrowth',
    colorSeries.lineChart.circleFillColor,
  ),
];
const chartsTotalCreditItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartTotalCredit,
    yExtentsLeftChartTotalCredit,
    YAxisLeftChartTotalCredit,
    XAxis,
    seriesLeftChartTotalCredit,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartTotalCredit,
    YAxisRightChartTotalCredit,
    null,
    seriesRightChartTotalCredit,
  ),
];

const configChartTotalCredit = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartTotalCredit,
  titleChartTotalCredit,
  chartsTotalCreditItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartTotalCredit

//#region configChartTotalDeposit
const yExtentsLeftChartTotalDeposit = ['deposit'];
const titleChartTotalDeposit = {
  title: 'snapShot.chartBank.chartTotalDeposit.title',
};
const YAxisLeftChartTotalDeposit = {
  ...ConstChart.setConfigYAxis(
    'left',
    'left',
    yGrid,
    titleYAxisLeft('snapShot.chartBank.chartTotalDeposit.yAxis1Title'),
  ),
  tickFormat: formatTick,
};
const seriesLeftChartTotalDeposit = [
  ConstChart.setConfigBarSeries(
    'deposit',
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColor,
    colorSeries.barChart.fillColorHover,
    colorSeries.barChart.fillColorHoverLight,
    true,
  ),
];
const HoverTooltipChartTotalDeposit = ConstChart.hoverTooltipFunc(
  null,
  null,
  null,
  [
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartTotalDeposit.tooltipDeposit',
      d => [d.category, formatTextFloat(d.deposit)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
    ConstChart.setContentTooltip(
      '',
      'snapShot.chartBank.chartTotalDeposit.tooltipGrowth',
      d => [d.category, formatTextFloat(d.depositGrowth)],
      SETTINGS.TEXT_COLOR_TOOLTIP,
    ),
  ],
);
const yExtentsRightChartTotalDeposit = ['depositGrowth'];
const YAxisRightChartTotalDeposit = {
  ...ConstChart.setConfigYAxis(
    'right',
    'right',
    {},
    titleYAxisRight('snapShot.chartBank.chartTotalDeposit.yAxis2Title'),
  ),
  tickFormat: formatTick,
};
const seriesRightChartTotalDeposit = [
  ConstChart.setConfigLineSeries(
    'depositGrowth',
    colorSeries.lineChart.circleFillColor,
    ConstChart.CircleMarker,
    typeCircleMarker,
    2,
    colorSeries.lineChartLight.circleFillColor,
    true,
  ),
];
const listLegendChartTotalDeposit = [
  ConstChart.setLegendConfig(
    ConstChart.BARCHART,
    'snapShot.chartBank.chartTotalDeposit.legendDeposit',
    colorSeries.barChart.fillColor,
  ),
  ConstChart.setLegendConfig(
    ConstChart.CIRCLEMARKERLINE,
    'snapShot.chartBank.chartTotalDeposit.legendGrowth',
    colorSeries.lineChart.circleFillColor,
  ),
];
const chartsTotalDepositItems = [
  ConstChart.setConfigChartItem(
    HoverTooltipChartTotalDeposit,
    yExtentsLeftChartTotalDeposit,
    YAxisLeftChartTotalDeposit,
    XAxis,
    seriesLeftChartTotalDeposit,
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRightChartTotalDeposit,
    YAxisRightChartTotalDeposit,
    null,
    seriesRightChartTotalDeposit,
  ),
];

const configChartTotalDeposit = ConstChart.configChartFunc(
  xAccessor,
  xExtents,
  SETTINGS.MARGIN,
  SETTINGS.HEIGHT,
  listLegendChartTotalDeposit,
  titleChartTotalDeposit,
  chartsTotalDepositItems,
  true,
  eventSynchTooltipName,
);
//#endregion configChartTotalDeposit

const listItemInforLeftBank = [
  {
    name: 'snapShot.tableInfor.marketCap',
    key: 'rtd11',
    unit: '',
    type: SETTINGS.formatBillion,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.ROE',
    key: 'rtq12',
    unit: '',
    type: SETTINGS.formatPercent,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.ROA',
    key: 'rtq14',
    unit: '',
    type: SETTINGS.formatPercent,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.LastestDiv',
    key: 'valuePerShare',
    unit: '',
    type: SETTINGS.formatTextFloat0,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.EPS',
    key: 'rtd14',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.EPSForward',
    key: 'rtd53',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.PE',
    key: 'rtd21',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.YRange',
    key: 'lowestPrice1Year',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: true,
    key2: 'highestPrice1Year',
  },
];
const listItemInforRightBank = [
  {
    name: 'snapShot.tableInfor.OutShare',
    key: 'outstandingShare',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
  },
  {
    name: 'snapShot.tableInfor.stateHolding',
    key: 'stateVolumn',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      key: 'statePercentage',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },
  {
    name: 'snapShot.tableInfor.foreignHolding',
    key: 'foreignerVolumn',
    unit: '',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    child: {
      key: 'foreignerPercentage',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },
  {
    name: 'snapShot.tableInfor.totalForeignRoom',
    key: 'totalForeignRoom',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      key: 'maximumForeignPercentage',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },

  {
    name: 'snapShot.tableInfor.foreignRoom',
    key: 'foreignerRoom',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
      render: item =>
        formatTextFloat(
          formatPercent(
            Math.max(
              item.maximumForeignPercentage - item.foreignerPercentage,
              0,
            ),
          ),
        ),
    },
  },
  {
    name: 'snapShot.tableInfor.freeFloat',
    key: 'freeFloat',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      key: 'freeFloatRate',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },
  {
    name: 'snapShot.tableInfor.PB',
    key: 'rtd25',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
    unit: '',
  },
  { name: 'snapShot.tableInfor.CEO', key: 'ceo', unit: '', type: '' },
];

const listItemInforRightNonBank = [
  {
    name: 'snapShot.tableInfor.OutShare',
    key: 'outstandingShare',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
  },
  {
    name: 'snapShot.tableInfor.stateHolding',
    key: 'stateVolumn',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      key: 'statePercentage',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },
  {
    name: 'snapShot.tableInfor.foreignHolding',
    key: 'foreignerVolumn',
    unit: '',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    child: {
      key: 'foreignerPercentage',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },
  {
    name: 'snapShot.tableInfor.totalForeignRoom',
    key: 'totalForeignRoom',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      key: 'maximumForeignPercentage',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },

  {
    name: 'snapShot.tableInfor.foreignRoom',
    key: 'foreignerRoom',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
      render: item =>
        formatTextFloat(
          formatPercent(
            Math.max(
              item.maximumForeignPercentage - item.foreignerPercentage,
              0,
            ),
          ),
        ),
    },
  },

  {
    name: 'snapShot.tableInfor.freeFloat',
    key: 'freeFloat',
    type: SETTINGS.formatMilliion,
    isYRange: false,
    unit: '',
    child: {
      key: 'freeFloatRate',
      type: SETTINGS.formatPercent,
      unit: 'snapShot.tableInfor.unitPercent',
    },
  },

  {
    name: 'snapShot.tableInfor.Competitors',
    key: 'competitors',
    unit: '',
    type: '',
  },

  {
    name: 'snapShot.tableInfor.CEO',
    key: 'ceo',
    unit: '',
    type: '',
  },
];
const listItemInforLeftNonBank = [
  {
    name: 'snapShot.tableInfor.marketCap',
    key: 'rtd11',
    unit: '',
    type: SETTINGS.formatBillion,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.ROE',
    key: 'rtq12',
    unit: '',
    type: SETTINGS.formatPercent,
    isYRange: false,
  },

  {
    name: 'snapShot.tableInfor.LastestDiv',
    key: 'valuePerShare',
    unit: '',
    type: SETTINGS.formatTextFloat0,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.DE',
    key: 'rtq10',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.PE',
    key: 'rtd21',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.EPS',
    key: 'rtd14',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.EPSForward',
    key: 'rtd53',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: false,
  },
  {
    name: 'snapShot.tableInfor.YRange',
    key: 'lowestPrice1Year',
    unit: '',
    type: SETTINGS.formatTextFloat,
    isYRange: true,
    key2: 'highestPrice1Year',
  },
];
const listItemBank = {
  listItemInforLeft: listItemInforLeftBank,
  listItemInforRight: listItemInforRightBank,
};
const listItemNonBank = {
  listItemInforLeft: listItemInforLeftNonBank,
  listItemInforRight: listItemInforRightNonBank,
};

const listBarChartNonBankingOneColumn = [
  { configChart: configChartRevenue },
  { configChart: configChartCapitalStructureRatio },
  { configChart: configChartProfitability },
  { configChart: configChartOperatingRatio },
  { configChart: configChartCashFlow },
  { configChart: configChartOperatingCashFlow },
  { configChart: configChartReturnOnCapital },
  { configChart: configChartDupont },
];

const listBarChartNonBankingTwoColumn = [
  { configChart: configChartRevenue },
  { configChart: configChartProfitability },
  { configChart: configChartCapitalStructureRatio },
  { configChart: configChartOperatingRatio },
  { configChart: configChartCashFlow },
  { configChart: configChartReturnOnCapital },
  { configChart: configChartOperatingCashFlow },
  { configChart: configChartDupont },
];

const listBarChartNonBankingThreeColumn = [
  { configChart: configChartRevenue },
  { configChart: configChartProfitability },
  { configChart: configChartCashFlow },
  { configChart: configChartCapitalStructureRatio },
  { configChart: configChartOperatingRatio },
  { configChart: configChartOperatingCashFlow },
  { configChart: configChartReturnOnCapital },
  { configChart: configChartDupont },
];

const listBarChartNonBankingFourColumn = [
  { configChart: configChartRevenue },
  { configChart: configChartProfitability },
  { configChart: configChartCashFlow },
  { configChart: configChartReturnOnCapital },
  { configChart: configChartCapitalStructureRatio },
  { configChart: configChartOperatingRatio },
  { configChart: configChartOperatingCashFlow },
  { configChart: configChartDupont },
];

const listBarChartBanking = [
  { configChart: configChartNetInterestIncome },
  { configChart: configChartNetProfit },
  { configChart: configChartBankTotalAsset },
  { configChart: configChartBadDebt },
  { configChart: configChartTotalCredit },
  { configChart: configChartTotalDeposit },
];
const listBarChart = {
  listBarChartNonBankingOneColumn,
  listBarChartNonBankingTwoColumn,
  listBarChartNonBankingThreeColumn,
  listBarChartNonBankingFourColumn,
  listBarChartBanking: listBarChartBanking,
};

const timeRange = {
  '1D': 'OneDay', // ONE_DAY
  '1W': 'OneWeek', // ONE_WEEK
  '1M': 'OneMonth', // ONE_MONTH
  '3M': 'ThreeMonths', // THREE_MONTHS
  '6M': 'SixMonths', // SIX_MONTHS
  YTD: 'YearToDate', // YEAR_To_DATE
  '1Y': 'OneYear', // ONE_YEAR
  '3Y': 'ThreeYears', // THREE_YEARS
  '5Y': 'FiveYears', // FIVE_YEARS
  // 'REALTIME': 0, // REALTIME
};

export default {
  listBarChart,
  listItemBank,
  listItemNonBank,
  exportConfigs,
  SETTINGS,
  DEFAULT_CODE: 'SSI',
  DEFAULT_CODE_NAME: 'SSI Securities Corp.',
  DEFAULT_EXCHANGE: 'HOSE',
  timeRange,
};
